import slideUp from './slideUp';
import slideDown from './slideDown';

export default function slideToggle(el, { speed = 300 } = {}) {
  if(window.getComputedStyle(el).display === 'none') {
    slideDown(el, { speed });
  } else {
    slideUp(el, { speed });
  }
}
